var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
} //  strict


import * as React from 'react';
import { Input } from 'semantic-ui-react';

var SemanticReduxFormField = function SemanticReduxFormField(_ref) {
  var input = _ref.input,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      warning = _ref$meta.warning,
      _ref$as = _ref.as,
      As = _ref$as === undefined ? Input : _ref$as,
      props = _objectWithoutProperties(_ref, ['input', 'meta', 'as']);

  var handleChange = function handleChange(e, _ref2) {
    var value = _ref2.value;
    return input.onChange(value);
  };

  return (// $FlowFixMe
    React.createElement('div', {
      className: 'field'
    }, React.createElement(As, _extends({}, input, {
      value: input.value
    }, props, {
      onChange: handleChange,
      error: touched && error
    })), touched && warning && React.createElement('span', null, warning))
  );
};

export default SemanticReduxFormField;